import { render, staticRenderFns } from "./VideosNode.vue?vue&type=template&id=12b08e2f&"
import script from "./VideosNode.vue?vue&type=script&lang=js&"
export * from "./VideosNode.vue?vue&type=script&lang=js&"
import style0 from "./VideosNode.vue?vue&type=style&index=0&id=12b08e2f&prod&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports